import LoadingStatus from 'enums/loadingStatus';
import { camelCaseObjectKeys } from 'utils/camelCase';

const searchCommandElement = document.querySelector("[data-component='search-command-data']");

// Result counts element with the listing counts information.
const resultCountsElement = document.querySelector("[data-component='results-counts-data']");

const initialState = camelCaseObjectKeys(JSON.parse(searchCommandElement.innerHTML));
const resultCounts = resultCountsElement ? JSON.parse(resultCountsElement.innerHTML) : {};
initialState.counts = {
  brands: [],
  listingCount: resultCounts?.totalListingCount || 0,
  spotlightListingsCount: resultCounts?.spotlightListingsCount || 0,
  adultCount: resultCounts?.adultCount || 0,
  comingSoonCount: resultCounts?.comingSoonCount || 0,
  hotDealsCount: resultCounts?.hotDealsCount || 0,
  buildablePlansCount: resultCounts?.buildablePlansCount || 0,
  quickMoveInCount: resultCounts?.quickMoveInCount || 0,
  multiFamilyCount: resultCounts?.multiFamilyCount || 0,
};

// We have to set those fetching statuses to idle as it does not have done anything.
// TODO: Implement the idle status after X time when it got the Succeeded or Failed status.
// In this way, we keep an up-to-date status.
initialState.fetchResultListingsStatus = LoadingStatus.Idle;
initialState.fetchResultCountsStatus = LoadingStatus.Idle;
initialState.fetchBrandsFacetingStatus = LoadingStatus.Idle;

export default initialState;
